import React from 'react';
import { useNavigate } from 'react-router';
import { PENDING_COURSES } from '../constants';
import { useStore } from '../store';

interface ILandingCourseProps {
  courseSection: any;
  settings: any;
}

// eslint-disable-next-line @typescript-eslint/no-var-requires
const getImg = (img: string) => require(`../../../assets/${img}`).default;

const LandingCourseSection: React.FunctionComponent<ILandingCourseProps> = ({
  courseSection,
  settings,
}) => {
  const navigate = useNavigate();
  const { language } = useStore();
  const gotoCoursePage = (course: string) => {
    if (language === 'sc' && PENDING_COURSES.includes(course)) {
      navigate(`/tc/course/${course}`);
    } else {
      navigate(`/${language}/course/${course}`);
    }
  };
  return (
    <div
      className={`course-section ${
        courseSection.page === 'cybersecurity2024'
          ? 'general2024'
          : courseSection.page
      }`}
    >
      <div className="introducing-circle" />
      <div className="course-content">
        <div className="course-content-left">
          <div className="course-title">
            {courseSection.courseTitle}
            {language === 'sc' &&
              PENDING_COURSES.includes(courseSection.page) && (
                <div className="course-message">
                  (*目前只提供繁体中文和英文)
                </div>
              )}
          </div>

          <p
            className="content"
            dangerouslySetInnerHTML={{
              __html: courseSection?.courseDetail,
            }}
          />
          <div className="course-time-steps">
            {courseSection.steps.map((itm: any, idx: number, arr: any[]) => (
              <div key={idx} className="course-time-steps-item">
                <div className="time">{itm.numTitle}</div>
                <div className="mask">
                  <div className="out-circle" />
                  {idx !== arr.length - 1 && <div className="line" />}
                </div>
                <div className="name">{itm.stepName}</div>
                <div className="desc">{itm.stepDesc}</div>
              </div>
            ))}
          </div>
          <div className="prize">{courseSection.coursePrizeText}</div>
          <div
            className="course-start-button"
            onClick={() => gotoCoursePage(courseSection.page)}
          >
            <span>{settings?.startYourTraining}</span>
            <div className="circle">
              <img
                width="42px"
                src={getImg(courseSection.AddPointIcon)}
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="course-content-right">
          <div className="course-content-right-img">
            <div className="rect1" />
            <div className="rect2" />
            <img
              width="100%"
              src={getImg(courseSection.imgTrainingIllustration)}
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingCourseSection;
